<template>
  <DialogBase
    title="Xuất file thống kê chi tiết học sinh"
    :visible.sync="localVisible"
    dialog-class="sk-dialog--md"
    panel-title="Tùy chọn xuất file"
    panel-subtitle="Chọn trạng thái hóa đơn để xuất dữ liệu chi tiết"
    panel-icon="el-icon-document"
    panel-icon-tone="success"
    confirm-text="Xuất Excel"
    cancel-text="Hủy"
    :confirm-loading="loadingExportFile"
    @cancel="handleCancel"
    @confirm="handleExportFile"
  >
    <div style="padding-top: 10px;">
      <el-radio-group v-model="selectExport" @change="handleRadioChange">
        <el-radio :label="1" style="margin-top: 10px; display: block">Xuất danh sách các học sinh chưa hoàn thành phiếu thu</el-radio>
        <el-radio :label="2" style="margin-top: 20px; display: block">Xuất danh sách các học sinh đã hoàn thành phiếu thu</el-radio>
        <el-radio :label="3" style="margin-top: 20px; display: block">Xuất danh sách các học sinh chưa có phiếu thu</el-radio>
        <el-radio :label="4" style="margin-top: 20px; display: block">Xuất danh sách các học sinh với tất cả trạng thái</el-radio>
      </el-radio-group>

      <div v-if="selectExport" style="margin-top: 30px; border-top: 1px solid #e2e8f0; padding-top: 20px;">
        <el-form label-position="top">
          <el-form-item label="Chọn thời gian">
            <el-date-picker
                style="width: 100%"
                format="MM-yyyy"
                value-format="yyyy-MM-dd"
                v-model="listMonth"
                type="monthrange"
                align="center"
                unlink-panels
                range-separator="-"
                start-placeholder="Tháng bắt đầu"
                end-placeholder="Tháng kết thúc"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="Tình trạng phiếu thu" v-if="selectExport !== 3">
            <el-checkbox-group v-model="selectStatus" class="status-checkbox-group">
              <template v-if="selectExport === 1">
                <el-checkbox label="UNPAID">Chưa đóng 100%</el-checkbox>
                <el-checkbox label="PARTIALLY_PAID">Chưa đóng đủ</el-checkbox>
              </template>
              <template v-if="selectExport === 2">
                <el-checkbox label="FULLY_PAID">Đóng đủ 100%</el-checkbox>
                <el-checkbox label="OVERPAID">Đóng thừa</el-checkbox>
                <el-checkbox label="FULLY_PAID_WITH_SURPLUS">Đóng đủ thừa</el-checkbox>
                <el-checkbox label="PAID_WITH_DEFICIT">Đóng đủ thiếu</el-checkbox>
              </template>
              <template v-if="selectExport === 4">
                <el-checkbox label="UNPAID">Chưa đóng 100%</el-checkbox>
                <el-checkbox label="PARTIALLY_PAID">Chưa đóng đủ</el-checkbox>
                <el-checkbox label="FULLY_PAID">Đóng đủ 100%</el-checkbox>
                <el-checkbox label="OVERPAID">Đóng thừa</el-checkbox>
                <el-checkbox label="FULLY_PAID_WITH_SURPLUS">Đóng đủ thừa</el-checkbox>
                <el-checkbox label="PAID_WITH_DEFICIT">Đóng đủ thiếu</el-checkbox>
              </template>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import { exportToExcel } from "@/commonFuncion/ExportExcelFEOnly";
import { mapGetters } from "vuex";
import TuitionStatisticService from "@/services/tutition_v3/TuitionStatisticService";

export default {
  name: "ExportStudentStatisticDialog",
  components: { DialogBase },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    filterData: {
      type: Object,
      default: () => ({}),
    },
    selectedList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectExport: 1,
      loadingExportFile: false,
      listMonth: [],
      selectStatus: [],
    };
  },
  computed: {
    ...mapGetters("schoolStore", ["schoolInfo"]),
    localVisible: {
      get() {
        return this.showDialog;
      },
      set(val) {
        if (!val) {
          this.$emit("close", false);
        }
      }
    }
  },
  methods: {
    handleRadioChange() {
      this.selectStatus = [];
    },
    handleCancel() {
      this.selectExport = 1;
      this.listMonth = [];
      this.selectStatus = [];
      this.$emit("close", false);
    },
    formatVND(number) {
      if (number === null || number === undefined || number === "") {
        return "";
      }
      return Number(number).toLocaleString("vi-VN");
    },
    getStatusName(statusKey) {
      const map = {
        "UNPAID": "Chưa đóng 100%",
        "PARTIALLY_PAID": "Chưa đóng đủ",
        "FULLY_PAID": "Đóng đủ 100%",
        "OVERPAID": "Đóng thừa",
        "FULLY_PAID_WITH_SURPLUS": "Đóng đủ thừa",
        "PAID_WITH_DEFICIT": "Đóng đủ thiếu",
      };
      return map[statusKey] || statusKey;
    },
    getStatusesByExportType(exportType, customStatuses) {
      switch (exportType) {
        case 1:
          return ['UNPAID', 'PARTIALLY_PAID'];
        case 2:
          return ['FULLY_PAID', 'OVERPAID', 'FULLY_PAID_WITH_SURPLUS', 'PAID_WITH_DEFICIT'];
        case 3:
        case 4:
          return [];
        default:
          return customStatuses || [];
      }
    },
    async handleExportFile() {
      if (!this.listMonth || this.listMonth.length === 0) {
        this.$message.warning("Vui lòng chọn thời gian xuất file");
        return;
      }
      if (this.selectExport !== 3 && this.selectStatus.length === 0) {
        this.$message.warning("Vui lòng chọn ít nhất một tình trạng phiếu thu");
        return;
      }

      this.loadingExportFile = true;
      try {
        const payload = {
          listIdClass: this.selectedList.map(item => item.targetId),
          exportType: this.selectExport,
          dateStart: this.listMonth[0],
          dateEnd: this.listMonth[1],
          statuses: this.getStatusesByExportType(this.selectExport, this.selectStatus),
          turn: this.filterData.turn || null,
          transactionEntry: this.filterData.transactionEntry || null,
          kidStatus: this.filterData.kidStatus || null,
          statusTargetType: this.filterData.statusTargetType,
        };

        const response = await TuitionStatisticService.exportDetailStudent(payload);
        const apiData = response.data && response.data.data ? response.data.data : [];

        if (apiData.length === 0) {
          this.$message.warning("Không có dữ liệu để xuất");
          return;
        }

        let titleName = "";
        let filterStatusStr = "";
        if (this.selectExport === 1) {
          titleName = "DANH SÁCH CÁC HỌC SINH CHƯA HOÀN THÀNH PHIẾU THU";
          filterStatusStr = this.selectStatus.map(val => this.getStatusName(val)).join(", ");
        } else if (this.selectExport === 2) {
          titleName = "DANH SÁCH CÁC HỌC SINH ĐÃ HOÀN THÀNH PHIẾU THU";
          filterStatusStr = this.selectStatus.map(val => this.getStatusName(val)).join(", ");
        } else if (this.selectExport === 3) {
          titleName = "DANH SÁCH CÁC HỌC SINH CHƯA CÓ PHIẾU THU";
          filterStatusStr = "Chưa có phiếu thu";
        } else {
          titleName = "DANH SÁCH CÁC HỌC SINH VỚI TẤT CẢ TRẠNG THÁI PHIẾU THU";
          filterStatusStr = this.selectStatus.length > 0 ? this.selectStatus.map(val => this.getStatusName(val)).join(", ") : "Tất cả";
        }

        if (this.filterData.turn) {
          titleName += ` - ĐỢT ${this.filterData.turn}`;
        }

        const classNameText = this.selectedList && this.selectedList.length > 0
          ? this.selectedList.map(item => item.targetName).join(", ")
          : (this.filterData.className || "Tất cả các lớp");
        
        const startMonth = this.listMonth[0] ? new Date(this.listMonth[0]).getMonth() + 1 : "";
        const startYear = this.listMonth[0] ? new Date(this.listMonth[0]).getFullYear() : "";
        const endMonth = this.listMonth[1] ? new Date(this.listMonth[1]).getMonth() + 1 : "";
        const endYear = this.listMonth[1] ? new Date(this.listMonth[1]).getFullYear() : "";
        const timeStr = `Tháng ${startMonth} năm ${startYear} tới tháng ${endMonth} năm ${endYear}`;

        const schoolName = this.schoolInfo && this.schoolInfo.schoolName ? this.schoolInfo.schoolName : "Mầm Non Phong Lan";

        const companyInfo = [
          `Trường : ${schoolName}`,
          `Lớp : ${classNameText}`,
          `Thời gian : ${timeStr}`,
          `Trạng thái : ${filterStatusStr}`,
        ];

        let columnHeaders = [];
        let columnWidths = [];
        let dataList = [];
        let otherObject = [];

        if (this.selectExport === 3) {
          columnHeaders = [
            "STT",
            "Tên học sinh",
            "Tên khối",
            "Tên lớp",
            "SĐT",
            "Trạng thái học",
            "Tháng chưa có phiếu thu",
          ];
          columnWidths = [5, 25, 15, 15, 15, 15, 25];
          dataList = apiData.map((x, index) => [
            index + 1,
            x.studentName,
            x.gradeName,
            x.className,
            x.phone,
            x.studyStatus,
            x.missingMonth,
          ]);
          otherObject = []; // No sum row for this case
        } else {
          columnHeaders = [
            "STT",
            "Tên học sinh",
            "Tên khối",
            "Tên lớp",
            "SĐT",
            "Trạng thái học",
            "Danh sách mã phiếu thu",
            "Trạng thái phiếu thu",
            "Thiếu thừa tháng trước",
            "Phải thu",
            "Đã thu",
            "Tiền mặt",
            "Chuyển khoản",
            "Thiếu thừa còn lại",
            "Chuyển thanh toán",
            "Ngày thanh toán",
          ];
          columnWidths = [5, 25, 15, 15, 15, 15, 25, 20, 22, 15, 15, 15, 15, 20, 20, 15];
          dataList = apiData.map((x, index) => [
            index + 1,
            x.studentName,
            x.gradeName,
            x.className,
            x.phone,
            x.studyStatus,
            x.invoiceList,
            x.receiptStatus,
            this.formatVND(x.beforeMoneyTotal),
            this.formatVND(x.sumMoneyTotal),
            this.formatVND(x.collectedMoneyTotal),
            this.formatVND(x.cashMoneyTotal),
            this.formatVND(x.transferMoneyTotal),
            this.formatVND(x.afterMoneyTotal),
            x.transferStatus,
            x.paymentDate || '',
          ]);

          let sumPhaiThu = 0;
          let sumConLai = 0;
          apiData.forEach(x => {
            sumPhaiThu += x.sumMoneyTotal || 0;
            sumConLai += x.afterMoneyTotal || 0;
          });

          otherObject = [
            "",
            "Tổng cộng :",
            "", "", "", "", "", "",
            "0",
            this.formatVND(sumPhaiThu),
            "0", "0", "0",
            this.formatVND(sumConLai),
            "", ""
          ];
        }

        const exportToExcelData = {
          titleFile: titleName,
          columnHeaders: columnHeaders,
          columnWidths: columnWidths,
          nameFile: "DanhSachHocSinh_ThongKeHocPhi",
          companyInfo: companyInfo,
          dataList: dataList,
        };

        await exportToExcel(exportToExcelData, otherObject);
        this.$message.success("Xuất file thành công!");
        
        // Reset select after success export
        this.selectExport = 1;
        this.listMonth = [];
        this.selectStatus = [];
        this.$emit("close", false);

      } catch (error) {
        const message = error.response?.data?.message || "Có lỗi xảy ra khi xuất file.";
        this.$message.error(message);
      } finally {
        this.loadingExportFile = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.status-checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}
</style>
